import React, { useState } from 'react';
import styles from './styles/ScenarioPassword.module.css';
import * as ScenarioAPI from '../../../services/ScenarioServices';

/**
 * Password gate for private scenarios.
 *
 * The check runs on the server: the scenario GET no longer ships the password,
 * so there is nothing here to compare against (or read out of the network tab).
 */
const ScenarioPassword = ({ scenarioId, setHasAccess, passwordError, setPasswordError }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const { valid } = await ScenarioAPI.verifyScenarioPassword(scenarioId, password);
            setHasAccess(valid);
            setPasswordError(!valid);
        } catch (err) {
            setPasswordError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.h2}>Enter Password</h2>
            <form onSubmit={handlePasswordSubmit} className={styles.form}>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`${styles.input} ${passwordError ? styles.errorInput : ''}`}
                    placeholder="Password"
                />
                {passwordError && <p className={styles.errorText}>Incorrect Password</p>}
                <button
                    type="submit"
                    className={styles.button}
                    disabled={loading}
                >
                    {loading ? 'Verifying...' : 'Submit'}
                </button>
            </form>
        </div>
    );
};

export default ScenarioPassword;
